export default "__VITE_ASSET__e0d6b150__"